import { defineStore } from 'pinia';
import type { FooterContent } from './types';
import footerService from './api';

type State = FooterContent;

export const useFooterStore = defineStore('Footer', {
	state: (): State => ({
		text: '',
	}),

	actions: {
		async getFooterContent() {
			const data = await footerService.fetchContent();

			if ('error' in data) {
				console.error();
				return null;
			}

			this.text = data.text;

			return data.text;
		},
	},
});
